import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { register } from 'swiper/element/bundle';

register();

const UiSwiper = forwardRef(({ children, ...rest }, ref) => {
  return (
    <swiper-container
      ref={ref}
      slides-per-view='auto'
      space-between='16'
      {...rest}
    >
      {children}
    </swiper-container>
  );
});

UiSwiper.propTypes = {
  children: PropTypes.node,
};

export default UiSwiper;
